import { useColorMap } from '../../hooks/queries/useEventTypes';

/** Pastille à la couleur de la tâche type dont la tâche vient. Rien si elle n'a pas de type ou pas de couleur. */
export function TaskTypeDot({ templateId }: { templateId: string | null | undefined }) {
  const colors = useColorMap();
  const color = templateId ? colors[templateId] : undefined;
  if (!color) return null;
  return (
    <span
      className="mr-1.5 inline-block h-2 w-2 flex-shrink-0 rounded-full align-middle"
      style={{ background: color }}
      aria-hidden
    />
  );
}
